@if (accountBalanceService.availableWallets | async; as wallets) {
    @if (wallets.length > 1 || (singleWallet && wallets.length > 0)) {
        <div class="wallet-dropdown" [ngClass]="{ 'hline-top-bottom': showExtendedInfo }">
            <div class="title">
                @if (showExtendedInfo) {
                    <span class="wallet-title">{{ siteCore.betslip.wallet.Wallet }}</span>
                }
                <div class="wallet" (click)="toggled(wallets.length)">
                    @if (wallets.length > 1) {
                        <span class="wallet-title-icon" [class.title-mobile]="mediaQuerySignal()">
                            <vn-icon size="16" [class.icon-color-alignment]="!mediaQuerySignal()" [name]="selectedWallet?.icon ?? ''" />
                        </span>
                    }
                    <span class="group-title">
                        <span class="wallet-type-title">{{ showExtendedInfo ? selectedWallet?.shortTitle : '' }}</span>
                        <span class="wallet-amount"> {{ selectedWallet?.amount | msCurrency: true }}</span>
                    </span>
                    @if (wallets.length > 1) {
                        <span [class.icon-color-alignment]="!mediaQuerySignal()" [class.group-arrows]="mediaQuerySignal()">
                            @if (expanded) {
                                <vn-icon name="theme-up" [size]="mediaQuerySignal() ? '12' : '8'" />
                            } @else {
                                <vn-icon name="theme-down" [size]="mediaQuerySignal() ? '12' : '8'" />
                            }
                        </span>
                    }
                </div>
            </div>
            @if (!bottomOptions) {
                <div class="wallet-options" [class.select-options]="!mediaQuerySignal()">
                    @if (expanded) {
                        <div class="select" [style.right.px]="right" [style.top.px]="top">
                            <div class="info-section paypal-info-section" (click)="showPayPalHelp()">
                                <vn-icon name="theme-info" class="expand-info" size="16" />
                            </div>
                            <div class="option-container">
                                @for (wallet of wallets; track wallet) {
                                    <div
                                        class="option"
                                        [ngClass]="{ active: wallet.type === selectedWallet?.type }"
                                        (click)="selectionChanged(wallet)">
                                        <div class="wallet-dropdown-item">
                                            <div class="expand-wallet-icon">
                                                <vn-icon size="16" [name]="wallet.icon" />
                                            </div>
                                            <div class="wallet-info">
                                                <span>{{ wallet.amount | msCurrency: true }}</span>
                                                <span class="wallet-label">{{ wallet.title }} </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }
    @if (bottomOptions && expanded) {
        <div class="overlay"></div>
    }
    @if (bottomOptions) {
        <div class="wallet-dropdown wallet-options bottom-options" [ngClass]="{ 'paypal-help': payPalHelp }">
            @if (expanded) {
                <div class="select" [style.right.px]="right" [style.top.px]="top">
                    <div class="info-section bottom-selection">
                        @if (!payPalHelp) {
                            <span class="options-title">{{ siteCore.betslip.linear.AccountBalance }}</span>
                        }
                        @if (payPalHelp) {
                            <span class="help-title">{{ siteCore.betslip.linear.ChooseWallet }}</span>
                        }
                        @if (!payPalHelp) {
                            <div class="info" (click)="showPayPalHelp(wallets.length)">
                                <vn-icon name="theme-info" size="16"></vn-icon>
                            </div>
                        }
                        <div class="options-close" (click)="toggled(wallets.length)">
                            <vn-icon name="theme-ex" size="14"></vn-icon>
                        </div>
                        <div class="line-switcher"></div>
                    </div>
                    <div class="option-container">
                        @if (payPalHelp) {
                            <div class="help-description">
                                <p>{{ siteCore.betslip.linear.PayPalHelpDescription1 }}</p>
                                <p>{{ siteCore.betslip.linear.PayPalHelpDescription2 }}</p>
                            </div>
                        }
                        @for (wallet of wallets; track wallet) {
                            <div
                                class="option"
                                [ngClass]="{ active: wallet.type === (preSelectedWallet ? preSelectedWallet.type : selectedWallet?.type) }"
                                (click)="payPalHelp ? setPreSelectedWallet(wallet, $event) : selectionChanged(wallet)">
                                <div class="wallet-dropdown-item">
                                    <div class="wallet-icon">
                                        <vn-icon size="16" [name]="wallet.icon"></vn-icon>
                                    </div>
                                    <div class="wallet-info">
                                        <span class="wallet-info-value">{{ wallet.amount | msCurrency: true }}</span>
                                        <span class="wallet-label">{{ wallet.title }} </span>
                                    </div>
                                </div>
                            </div>
                        }
                        @if (payPalHelp) {
                            <a class="btn btn-primary btn-md" (click)="selectionChanged(preSelectedWallet || selectedWallet)">{{
                                siteCore.betslip.linear.Confirm
                            }}</a>
                        }
                    </div>
                </div>
            }
        </div>
    }
    @if (payPalHelp && !bottomOptions) {
        <ms-wallet-help (close)="closePayPalHelp()"></ms-wallet-help>
    }
}
